import UltMeta, { Meta } from "./UltMeta/index";

// 出入库类型
class BoundType extends UltMeta {
    PURCHASE_INBOUND = new Meta(1, "采购入库");
    REFUND_NECK_INBOUND = new Meta(2, "退领入库");
    ALLOT_INBOUND = new Meta(3, "调拨入库");
    INVENTORY_PROFIT_INBOUND = new Meta(4, "盘盈入库");
    SALES_RETURNS_INBOUND = new Meta(5, "销售退货入库");
    PLEDGE_INBOUND = new Meta(16, "质押入库");
    OTHER_INBOUND = new Meta(6, "其他入库");
    SELLER_OUTBOUND = new Meta(7, "销售出库");
    ALLOT_OUTBOUND = new Meta(8, "调拨出库");
    USE_OUTBOUND = new Meta(9, "领用出库");
    INVENTORY_LOSS_OUTBOUND = new Meta(10, "盘亏出库");
    REJECT_GOODS_OUTBOUND = new Meta(11, "退货出库");
    SCRAP_OUTBOUND = new Meta(12, "报废出库");
    OTHER_OUTBOUND = new Meta(13, "其他出库");
}

export const BOUND_TYPE = new BoundType();

// 业务类型 1入库 2出库 3买入过户、4 卖出过户
class InventoryDetailsBusinessType extends UltMeta {
    INBOUND = new Meta(1, "入库");
    OUTBOUND = new Meta(2, "出库");
    BUY_TRANSFER = new Meta(3, "买入过户");
    SELL_TRANSFER = new Meta(4, "卖出过户");
}

export const INVENTORY_DETAILS_BUSINESS_TYPE = new InventoryDetailsBusinessType();
